export enum Actions {
  INSERTED = 'Ingresada',
  DERIVATED = 'Derivada',
  RESTORED = 'Recuperada',
  STATE_CHANGE = 'Cambio estado',
  UNSUSCRIBED = 'Dada de baja',
}
